import useDeviceStore from '@/store/device';
import { storeToRefs } from 'pinia';

export const useDevice = () => {
  const deviceStore = useDeviceStore();
  const { deviceId, deviceToken, hasDeviceId, hasDeviceToken } = storeToRefs(deviceStore);
  const { resetDevice } = deviceStore;

  const { pending: isRegistering, execute: register } = useSubmit();
  const { pending: isUnregistering, execute: unregister } = useSubmit();

  const registerDevice = async (token: string, id: string): void => {
    if (!token || !id || hasDevice.value || isRegistering.value) return;

    isRegistering.value = true;

    await register('/devices', {
      method: 'POST',
      body: {
        device_id: id,
        device_token: token,
      },
    });

    deviceId.value = id;
    deviceToken.value = token;

    isRegistering.value = false;
  };

  const unregisterDevice = async (): void => {
    if (isUnregistering.value) return;
    isUnregistering.value = true;

    await unregister('/devices', {
      method: 'DELETE',
      body: {
        device_id: deviceId.value,
        device_token: deviceToken.value,
      },
    });

    resetDevice();

    isUnregistering.value = false;
  };

  const hasDevice = computed((): boolean => {
    return hasDeviceId.value && hasDeviceToken.value;
  });

  return {
    hasDevice,

    registerDevice,
    unregisterDevice,
  };
};
